import React from 'react';
import './ToolCard.css';

const ToolCard = ({ icon, title, description, onClick, gradient }) => {
    return (
        <div className="tool-card" onClick={onClick}>
            <div className={`tool-icon ${gradient}`}>
                {icon}
            </div>
            <h3 className="tool-title">{title}</h3>
            <p className="tool-description">{description}</p>
            <div className="tool-arrow">→</div>
        </div>
    );
};

export default ToolCard;
